import React from "react";
import { useSignal, viewport } from "@telegram-apps/sdk-react";
import { useServiceType } from "@/utils/hooks/useServiceType";
import cls from "./styles.module.scss";

export default function Watermarks() {
  const insetTop = useSignal(viewport.safeAreaInsetTop);
  const contentInsetTop = useSignal(viewport.contentSafeAreaInsetTop);
  const { isSravniDohod } = useServiceType();
  const text = isSravniDohod ? `@SravniDohod_bot` : `@${__BOT_NAME__}`;
  return (
    <>
      <div
        className={cls.watermark}
        style={{ top: `${60 + insetTop + contentInsetTop}px` }}
      >
        {text}
      </div>
    </>
  );
}
